import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import {BASE} from '../api/api'
import cachios from 'cachios'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import { List } from 'react-content-loader'
import ReactHtmlParser from 'react-html-parser';
import './cluster.css'
import pdf from '../assets/pdfd.png'

class Project extends Component {
    constructor(props) {
        super(props);
        this.state={
            cluster:'',
            id:props.match.params.id,
            year_keys:[],
            yearfill:'',
            cycylefill:'',
            cycle_keys:[],
            value:[],
            types:[],
            project:''
        }
    
      }
      topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    setfilter(type,ind,i){
            let types=this.state.types
            let value=this.state.value
            console.log(types,'xxx',value)

            let dt = value.indexOf(ind)
            if (dt > -1) {
                value.splice(dt, 1);
                types.splice(dt,1)
            }
            else {
                value.push(ind)
                types.push(type) 
            }
                
            this.setState({
                value:value,
                types:types
            })
            if(type==='year'){
                    let year_keys=this.state.year_keys
                    year_keys[i]=!year_keys[i]
                    this.setState({
                        year_keys:year_keys
                    })
            }        
            else{
                    let cycle_keys=this.state.cycle_keys
                    cycle_keys[i]=!cycle_keys[i]
                    this.setState({
                        cycle_keys:cycle_keys
                    })                    
            }
            let filter_arr=[]
            value.map((val,ind)=>{
                    filter_arr.push('projects['+(ind+1)+']='+types[ind]+':'+value[ind])
            })
            this.project(filter_arr.join('&'))
            console.log(filter_arr.join('&'),'filter')
            this.setState({
                filter:filter_arr.join('&')
            })
            

    }
    

    project(filter){
        this.setState({
            project:''
        })
        if(localStorage.getItem('token'))
            this.checkexpiry()
        if(filter===null){
            
            cachios.get(BASE+'api/research_cluster_search?projects[0]=research_clusters:'+this.state.id, {
                ttl: 500 /* seconds */,
                })
                .then((data) => {
                    console.log(data.data.data,'api')
                    this.setState({
                        project:data.data.data
                    })
                })
                .catch((err) => {
                    console.log('not found')
                })
        }

        else{
           
            cachios.get(BASE+'api/research_cluster_search?projects[0]=research_clusters:'+this.state.id+'&'+filter, {
                ttl: 500 /* seconds */,
                })
                .then((data) => {
                    console.log(data.data.data,'api')
    
                    this.setState({
                        project:data.data.data
                    })
                })
                .catch((err) => {
                    console.log('not found')
                })
        }
        

    }
    signout() {
        localStorage.removeItem('token');
        localStorage.removeItem('expirytime');
        localStorage.removeItem('expiryref');
        // window.location.href = '/'
    
      }
    
    
      refreshexp(){
        let s = new Date();
        s.setSeconds(s.getSeconds()+1800);
        localStorage.setItem('expiryref', s)
      }
    
    
      checkexpiry(){
        if(localStorage.getItem('expiryref')){
          let expref=Date.parse(localStorage.getItem('expiryref'))
          let s = new Date();
          if(s>expref){
              this.signout()
          }
          else{
            this.refreshexp()
          }
          
        }
        else{
          this.signout()  
      }
      }
    
    
        
       componentWillMount(){

         this.topFunction();
         this.project(null)
        // research cluster
        

        cachios.get(BASE+'jsonapi/node/research_cluster?filter[typeFilter][condition][path]=drupal_internal__nid&filter[typeFilter][condition][value]='+this.state.id, {
            ttl: 500 /* seconds */,
            })
            .then((data) => {
                console.log(data,'api')

                this.setState({
                    cluster:data.data.data[0]
                })
            })
        
        


        // yearFilter
        cachios.get(BASE+'year_restapi', {
            ttl: 500 /* seconds */,
            })
        .then((f_data) => {
           
                this.setState({
                    years:f_data.data
                })
                let arr=[]
                let year_keys=[]
                year_keys=f_data.data.map((val,i)=>{
                    arr.push(false)
                })
                this.setState({
                    year_keys:year_keys
                })

            })

            .catch((err) => {
                console.log(err.response)
            })

        // cycyle filter
        cachios.get(BASE+'cycle_restapi', {
            ttl: 500 /* seconds */,
            })
            .then((f_data) => {
            
                this.setState({
                    cycles:f_data.data
                })
                let arr=[]
                let cycle_keys=[]
                cycle_keys=f_data.data.map((val,i)=>{
                    arr.push(false)
                })
                this.setState({
                    cycle_keys:cycle_keys
                })

            })

            .catch((err) => {
                console.log(err.response)
            })

    }
render() {
    return (
        <div className='searchpage archive_page project_page'>
                <Header langSelected={(e) => this.langSelected(e)} />
                {this.state.cluster?<div className="page-title">
                        <div className="title-wrapper">
                            <div className="container">
                                <h1 className="page-header">{this.state.cluster.attributes.title}</h1>
                            </div>
                        </div>
                    </div>:''}

                <div className="main-content listing">
                    <div className="container newsrea">
                        <div className="row" >
                         

                            <div className="region region-content search_inner_container">

                                <div className="filter_block">
                                    <div className="filter_container">
                                    
                                    {this.state.years ? 
                                         
                                         <div className="filter_inner_wrapper">
                                             <div>
                                                 <h3 className="title">
                                                     <div className="filter_key">Year</div>
                                                 </h3>
                                                 <div className="filter_inner_wrpr">
                                                     {this.state.years? this.state.years.map((val_arr, ind) => {
                                                         return (
                                                             <div className="selct_container" >
                                                                 <div style={{ background:this.state.year_keys[ind]?'#165E84':''}} className="selct_box" onClick={() => this.setfilter('year',val_arr.year,ind)} ></div>
                                                                 <div className="selct_value" onClick={() => this.setfilter('year',val_arr.year,ind)} >{val_arr.year}</div>
                                                             </div>
                                                         )
                                                     }) : ''}
                                                     
                                                 </div>
                                                 
                                             </div>
                                                          
                                         </div>
                                     
                                 : ''}
                                        {this.state.years ?<div className='filter_border'></div>:''}
                                        {this.state.cycles ? 
                                         
                                         <div className="filter_inner_wrapper">
                                             <div>
                                                 <h3 className="title">
                                                     <div className="filter_key">Cycle</div>
                                                 </h3>
                                                 <div className="filter_inner_wrpr">
                                                     {this.state.cycles? this.state.cycles.map((val_arr, ind) => {
                                                         return (
                                                             <div className="selct_container" >
                                                                 <div className="selct_box" onClick={() => this.setfilter('cycle',val_arr.field_cycle_1,ind)} style={{ background:this.state.cycle_keys[ind]?'#165E84':''}} ></div>
                                                                 <div className="selct_value" onClick={() => this.setfilter('cycle',val_arr.key,ind)} >{val_arr.field_cycle}</div>
                                                             </div>
                                                         )
                                                     }) : ''}
                                                     
                                                 </div>
                                                 
                                             </div>
                                                          
                                         </div>
                                     
                                         : ''}
                                        {this.state.years ?<div className='filter_border'></div>:''}  
                                      
                                     

                                    </div>



                                </div>
                                <div className="search_block">
                                    
                                <div className="main-content listing">
                                        <div className="basicpage">
                                            <div className="row">
                                                <div className="region region-content">
                                                    <div className="listings">
                                                        {this.state.cluster?ReactHtmlParser(this.state.cluster.attributes.body.processed):<List/>}
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.project ? <div className="listings">
                                                <div className='project_header' style={{fontWeight:'600'}}>Projects </div>
                                                             
                                            </div>  :''}              
                                            
                                            {this.state.project ?
                                                <div className="projects">
                                                    {this.state.project.length!=0 ?this.state.project.map((inst, index) => {
                                                        return (

                                                            
                                                            <div className='project_list'>
                                                                <div className="title">

                                                                    <span className="field-content">
                                                                        <div className='project_head'>
                                                                            {inst.title[0].charAt(0).toUpperCase()+ inst.title[0].slice(1)}
                                                                        </div>
                                                                        {inst.field_members_title?inst.field_members_title.length!==0?
                                                                        inst.field_members_title.map((member,index)=>{
                                                                        return <Link to={'/faculty/'+member+'?nid='+inst.field_members[index]}  className='project_members'>
                                                                                    {member}{index===inst.field_members_title.length-1?'':','}
                                                                                </Link>}):'':''}

                                                                        <div className='cyc_year'>
                                                                            <div className='cyc_year_sub'>
                                                                                {inst.field_projects_year[0]}
                                                                            </div>
                                                                            <div className='cyc_year_sub'>
                                                                                {inst.cycle_name[0]}
                                                                            </div>
                                                                        </div>

                                                                        {/* <div className='proj_author'>
                                                                            Author names
                                                                        </div> */}

                                                                        {inst.body?<div className='proj_body'>
                                                                        {ReactHtmlParser(inst.body[0])}
                                                                            
                                                                        </div>:''}

                                                                        {inst.file_url?<div className='proj_pdf'>
                                                                            <img src={pdf} alt='pdf'/>
                                                                            <a href={BASE+inst.file_url[0]}>Download</a>
                                                                        </div>:''}

                                                                    </span>
                                                                </div>

                                                            </div>
                                                        )
                                                    }):'No Projects'}

                                                            
                                                    
                                                </div> :''}
                                        </div>
                                                      
                                    </div>                             


                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                <div class="button-responsive">
                    <button  onClick={()=>this.setState({
                        fpopup:!this.state.fpopup
                    })} class="filter">Filter</button>
                        <i class="filter-icon"></i>
                </div>
                {/* MObile FIlter */}
                <div className='mobile_filter' style={{display:this.state.fpopup?'':'none'}}>
                    <div className='mobile_filter_head' ><div>Filters</div><div onClick={()=>this.setState({
                        fpopup:!this.state.fpopup
                    })}>X</div></div>
                    <div className="filter_block">
                                    <div className="filter_container">
                                    
                                    {this.state.years ? 
                                         
                                         <div className="filter_inner_wrapper">
                                             <div>
                                                 <h3 className="title">
                                                     <div className="filter_key">Year</div>
                                                 </h3>
                                                 <div className="filter_inner_wrpr">
                                                     {this.state.years? this.state.years.map((val_arr, ind) => {
                                                         return (
                                                             <div className="selct_container" >
                                                                 <div style={{ background:this.state.year_keys[ind]?'#165E84':''}} className="selct_box" onClick={() => this.setfilter('year',val_arr.year,ind)} ></div>
                                                                 <div className="selct_value" onClick={() => this.setfilter('year',val_arr.year,ind)} >{val_arr.year}</div>
                                                             </div>
                                                         )
                                                     }) : ''}
                                                     
                                                 </div>
                                                 
                                             </div>
                                                          
                                         </div>
                                     
                                 : ''}
                                        {this.state.years ?<div className='filter_border'></div>:''}
                                        {this.state.cycles ? 
                                         
                                         <div className="filter_inner_wrapper">
                                             <div>
                                                 <h3 className="title">
                                                     <div className="filter_key">Cycle</div>
                                                 </h3>
                                                 <div className="filter_inner_wrpr">
                                                     {this.state.cycles? this.state.cycles.map((val_arr, ind) => {
                                                         return (
                                                             <div className="selct_container" >
                                                                 <div className="selct_box" onClick={() => this.setfilter('cycle',val_arr.field_cycle_1,ind)} style={{ background:this.state.cycle_keys[ind]?'#165E84':''}} ></div>
                                                                 <div className="selct_value" onClick={() => this.setfilter('cycle',val_arr.key,ind)} >{val_arr.field_cycle}</div>
                                                             </div>
                                                         )
                                                     }) : ''}
                                                     
                                                 </div>
                                                 
                                             </div>
                                                          
                                         </div>
                                     
                                         : ''}
                                        {this.state.years ?<div className='filter_border'></div>:''}  
                                        
                                    
                                     
                                    
                                      
                                       
                                 <div class="button-responsive">
                                    <button  onClick={()=>this.setState({
                                        fpopup:!this.state.fpopup
                                    })} class="filter">Apply Filter</button>
                                        <i class="filter-icon"></i>
                                </div>

                                    </div>



                                </div>

                </div>
                    <div className='search_footer'><Footer /></div>
            </div>
        // <div className='project_page formrea yourwork sub_work'>
        //             <Header />

        //     {/* filter section */}
        //     <div className="region region-content search_inner_container">

        //         <div className="filter_block">
        //             <div className="filter_container">
                    
        //             {this.state.search_keys3 ? 
                        
        //                 <div className="filter_inner_wrapper">
        //                     <div>
        //                         <h3 className="title">
        //                             <div className="filter_key">Publications</div>
        //                         </h3>
        //                         <div className="filter_inner_wrpr">
        //                             {this.state.search_filter_list3? this.state.search_filter_list3.map((val_arr, ind) => {
        //                                 return (
        //                                     <div className="selct_container" >
        //                                         <div className="selct_box" onClick={() => this.setFilter('publications:'+this.state.search_keys3[ind])} style={{ background: this.state['publications:'+this.state.search_keys3[ind]] ? this.state['publications:'+this.state.search_keys3[ind]] == true ? '#165E84' : '' : '' }}></div>
        //                                         <div className="selct_value" onClick={() => this.setFilter('publications:'+this.state.search_keys3[ind])} >{val_arr}</div>
        //                                     </div>
        //                                 )
        //                             }) : ''}
                                    
        //                         </div>
                                
        //                     </div>
                                        
        //                 </div>
                    
        //         : ''}
        //             </div>
        //         </div>
        //     </div>


            
            
        //     <div className="listing">


        //             {this.state.cluster?<div className="page-title">
        //                 <div className="title-wrapper">
        //                     <div className="container">
        //                         <h1 className="page-header">{this.state.cluster.attributes.title}</h1>
        //                     </div>
        //                 </div>
        //             </div>:''}
        //             <div className="main-content listing">
        //                 <div className="container basicpage">
        //                     <div className="row">
        //                     <div className="region region-content">
        //                         <div className="listings">
        //                         {this.state.cluster?ReactHtmlParser(this.state.cluster.attributes.body.processed):<List/>}

        //                         </div>
        //                     </div>
        //                     </div>
        //                 </div>
        //             </div>  

        //             <div className="page-title">
        //                 <div className="title-wrapper">
        //                     <div className="container">
        //                         <h1 className="page-header">Projects</h1>
        //                     </div>
        //                 </div>
        //             </div> 

        //                 <div className="main-content">
        //                     <div className="container">
        //                         <div className="row">
        //                             <div className="region region-content">
        //                                 <div className="listings">
        //                                     {this.state.project ?
        //                                         <div className="mission">
        //                                             {this.state.project.map((inst, index) => {
        //                                                 return (
        //                                                     <div>
        //                                                         <div className="title">
        //                                                             <span className="field-content">
        //                                                                 <Link onClick={()=>this.pagestore(this.state.offset)} to={{ pathname: '/article_desc/'+`${inst.attributes.title.replace(/ /g,"-").toLowerCase()}`+'?nid=' + `${inst.attributes.drupal_internal__nid}`, state: { dat_arr: inst.attributes } }}>
        //                                                                 {inst.attributes.title}
        //                                                                 </Link>
        //                                                             </span>
        //                                                         </div>

        //                                                     </div>
        //                                                 )
        //                                             })}
                                                    
        //                                         </div> : <List />

        //                                     }


        //                                 </div>
        //                             </div>


        //                         </div>
        //                     </div>
        //                 </div>
        //     </div>
           
        //             <Footer />
        // </div>
            )
    
    
}

}


export default Project;
